export default __webpack_public_path__ + "static/media/avatar.c1516f96.png";